import { type MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import { type CommandMenuGroup } from '@/command-menu/types/CommandMenuGroup';

// Display order of the groups.
export const COMMAND_MENU_GROUPS: {
  id: CommandMenuGroup;
  label: MessageDescriptor;
}[] = [
  { id: 'navigation', label: msg`Navigation` },
  { id: 'actions', label: msg`Actions` },
];
